// React/Components
import React from "react";
import Profile from "./views/Profile";

const App = () => {
  return (
    <main id='App'>
      <Profile />
      <h3>React App Ready -.</h3>
    </main>
  );
};

export default App;
